import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgModule } from '@angular/core';
import { MasterComponent } from './master/master.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { MenuResponsivoComponent } from './master/menu-responsivo/menu-responsivo.component';
import { P404Component } from './error/404.component';
import { P500Component } from './error/500.component';
import { LoaderComponent } from './loader/loader.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  declarations: [
    MasterComponent,
    FooterComponent,
    MenuResponsivoComponent,
    P404Component,
    P500Component,
    LoaderComponent,
  ],
  imports: [
    MatMenuModule,
    MatSidenavModule,
		MatExpansionModule,
    MatToolbarModule,
    MatListModule,
    SharedModule,
    MatProgressSpinnerModule
  ],
  exports: [
    MasterComponent,
    FooterComponent,
    MenuResponsivoComponent
  ]
})
export class LayoutsModule { }
